import React from "react"
import CalendarIcon from "app/components/Icons/CalendarIcon"
import { format } from "date-fns"
import { Calendar } from "app/components/Calendar"
import { Popover, PopoverTrigger, PopoverContent } from "app/components/Popover/index"

interface DatePickerProps {
  label?: string
  value: Date | null
  onChange: (date: Date | null) => void
  disabled?: boolean
  placeholder?: string
  className?: string
  error?: string
  labelClassName?: string
  innerContainerClassName?: string
  align?: "start" | "center" | "end"
  minDate?: Date | null
  maxDate?: Date | null
  openProp?: boolean
  setOpen?: (open: boolean) => void
  hideIcon?: boolean
}

export default function DatePicker({
  label,
  value,
  onChange,
  disabled,
  className,
  error,
  labelClassName,
  innerContainerClassName,
  align = "start",
  placeholder="Choose date...",
  minDate,
  maxDate,
  openProp,
  setOpen,
  hideIcon = false,
}: DatePickerProps) {
    const [open, setOpenState] = React.useState(openProp ?? false)
      console.log("DatePicker re-render", {value})
    return (
      <Popover open={open} onOpenChange={(open) => {
          if (setOpen) setOpen(open)
          setOpenState(open)
        }}>
        <PopoverTrigger asChild>
          <div className="relative">
            <div className={`flex flex-col gap-[6px] ${innerContainerClassName}`}>
              {
                label &&
                <label className={`text-xs leading-[18px] text-[#79808A] ${labelClassName}`}>{label}</label>
              }
              <button
                disabled={disabled}
                className={`flex items-center justify-between text-sm leading-[21px] gap-[8px] h-[48px] flex-row border rounded-[4px] py-[16px] px-[10px] ${className} ${open ? '!border-[#79808A]' : 'border-[#E9ECF2]'} ${error && 'border-danger'} ${disabled && 'opacity-50'}`}
              >
                {value ? format(value, "dd MMM, yyyy") : <span>{placeholder}</span>}
                {
                  hideIcon ? null : <CalendarIcon 
                    size={20} 
                    color={error ? "#EB5757" : "#79808A"}
                  />
                }
              </button>
            </div>
          
            {
              error &&
              <span className="text-[11px] leading-[18px] text-danger absolute bottom-[-18px]">{error}</span>
            }
          </div>
        </PopoverTrigger>
        <PopoverContent align={align} className={`w-[222.798px] !px-4 !py-3 bg-white border border-[#E9ECF2]`}>
          <Calendar
            mode="single"
            selected={value ?? undefined}
            onSelect={(val) => onChange(val)}
            required={true}
            disabled={(date: Date) => {
              if (minDate && date < minDate) return true
              if (maxDate && date > maxDate) return true
              return false
            }}
          />
        </PopoverContent>
      </Popover>
    )
}